import { call, put, takeLatest } from 'redux-saga/effects';
import { actions, types } from './duck';
import { getAllUsers} from './api';
import { OK } from 'http-status-codes';

function* getAllUsersSaga() {
  try {
    yield put(actions.getAllUsersRequest());

    const response = yield call(getAllUsers);
    if (response.status === OK) {
      yield put(actions.getAllUsersSuccess(response.data));
    } else {
      yield put(actions.getAllUsersFailure(response.statusText));
    }
  } catch (error) {
    yield put(actions.getAllUsersFailure(error.message));
  }
}

export default function* saga() {
  yield takeLatest(types.GET_ALL_USERS, getAllUsersSaga);
}
